import { appendIf } from '@btime/helpers'
import { compose, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'

import { qrcodesClient } from '../../../../utils/apollo/api'
import { useNavigationWithModalCloser } from '../../../../utils/contexts/NavigationContext'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertBucket($input: BucketInput!) {
    upsertBucket(input: $input) {
      id
    }
  }
`

const cleanRequest = compose(pick(['id', 'name', 'activated', 'qrcodesCount', 'type']))

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(!form.name, { path: ['name'], message: 'Campo obrigatório' }),
    ...appendIf(!form.qrcodesCount, { path: ['qrcodesCount'], message: 'Campo obrigatório' })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveBuckets = () => {
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Bucket', 'Buckets'], client: qrcodesClient })
  const notify = useNotification()
  const {
    data: { type }
  } = useCurrentModal()
  const navigate = useNavigationWithModalCloser()

  const handleRequest = (form, actions) => {
    const input = cleanRequest({ ...form, type })
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          notify.success({ title: 'Lote gerado com sucesso! :)' })
          navigate(`/buckets/${resp.data.upsertBucket.id}/pdf`)
        }
        if (resp.errors) notify.error({ title: 'Ocorreu um erro ao gerar o lote! :(' })
      })
    }
  }

  return [handleRequest, state]
}
